import React, { useEffect, useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CollapseBlock } from '../../../../common/index';
import { Spinner } from '../../../../common/index';
import { routes } from '../../../../../utils/helpers/ApiClient';
import { AppBarCMS } from '../../../../basic/index';
import { Modal } from 'antd';
import {
  useGetErasmusConsortiumsQuery,
  useGetErasmusConsortiumQuery,
  useDeleteErasmusConsortiumMutation,
} from '../../../../../redux/services/erasmusConsortium';
import { useGetErasmusUniversitiesQuery } from '../../../../../redux/services/erasmusUniversities';
import ErasmusConsortiumTable from './ErasmusConsortiumTable';
import { useToastMessages } from '../../../../../hooks/useToastMessages';
import ErasmusConsortiumForm from './ErasmusConsortiumEdit/ErasmusConsortiumForm/ErasmusConsortiumForm.jsx';

const ErasmusConsortiumPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { deleteSuccess: toastDeleteSuccess } = useToastMessages();

  const { data: erasmusConsortiums, isLoading, refetch } = useGetErasmusConsortiumsQuery();
  const { data: universities } = useGetErasmusUniversitiesQuery();
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewId, setPreviewId] = useState(null);
  const { data: previewDetail, isLoading: isPreviewLoading } = useGetErasmusConsortiumQuery(
    previewId,
    { skip: !previewId },
  );
  const [
    deleteErasmusConsortiums,
    { isSuccess: isDeleteSuccess},
  ] = useDeleteErasmusConsortiumMutation();

  const previewUniversities = useMemo(
    () => previewDetail?.consortium?.universities || [],
    [previewDetail],
  );

  useEffect(() => {
    if (isDeleteSuccess) {
      toastDeleteSuccess();
      refetch();
    }
  }, [isDeleteSuccess]);

  return isLoading ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={t('Správa konzorcií')}
        backUrl={routes.cmsDashboard}
        backUrlTooltip={t('Nástenka')}
        createText={t('Nové konzorcium')}
        createUrl={routes.cmsErasmusConsortiumCreate}
        permissionsBasic={'erasmus-consortiums'}
      />
      <div style={{ margin: '10px' }}>
        <CollapseBlock>
          <ErasmusConsortiumTable
            erasmusConsortiums={erasmusConsortiums}
            onDelete={(record) => deleteErasmusConsortiums(record.id)}
            onDetailClick={(record) => {
              navigate(`${routes.cmsErasmusConsortiumEdit}/${record.id}`);
            }}
            onPreviewClick={(record) => {
              setPreviewId(record?.id);
              setPreviewOpen(true);
            }}
          />
        </CollapseBlock>
      </div>

      <Modal
        open={previewOpen}
        title={t('Náhľad konzorcia')}
        onCancel={() => setPreviewOpen(false)}
        footer={null}
        width={980}
      >
        {isPreviewLoading || !previewDetail || !universities ? (
          <Spinner />
        ) : (
          <ErasmusConsortiumForm
            initials={{
              ...previewDetail.consortium,
            }}
            isPreview={true}
            universities={universities}
            filteredUniversities={previewUniversities}
            onConsortiumUniDelete={() => {}}
            onSubmit={() => {}}
          />
        )}
      </Modal>
    </>
  );
};

export default ErasmusConsortiumPage;
